const Subscriptions = ({ props }) => (
<svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5.05605 1.37805V4.93361M13.9449 1.37805V4.93361M6.83382 9.96914L8.55502 11.9362C8.73835 12.1457 9.06697 12.1371 9.23897 11.9181L12.1672 8.19137M17.5005 4.93361V15.6003C17.5005 16.5821 16.7046 17.3781 15.7227 17.3781H3.27827C2.29643 17.3781 1.50049 16.5821 1.50049 15.6003V4.93361C1.50049 3.95177 2.29643 3.15583 3.27827 3.15583H15.7227C16.7046 3.15583 17.5005 3.95177 17.5005 4.93361Z" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
);

export default Subscriptions;
